import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PosOperator } from '../../_models/fundraising/PosOperator';
import { OperatorService } from '../../_services/fundraising/operator.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { OperatorStationLinkModalComponent } from './operator-station-link-modal.component';

@Component({
  selector: 'app-operator-management',
  templateUrl: './operator-management.component.html',
  styleUrls: ['../../_shared/base.management.component.css']
})

export class OperatorManagementComponent implements OnInit {
  public loading = true;

  public displayOperators: PosOperator[];
  public items: PosOperator[];

  public searchText: string;
  public showInactive = false;

  private bsModalRef: BsModalRef;

  constructor(
    private router: Router,
    private operatorService: OperatorService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService) {

  }

  ngOnInit() {
    this.load();
  }

  private filterName(name: string, searchQuery: string): boolean {
    return name.toLowerCase().includes(searchQuery.toLowerCase())
  }

  public search() {
    this.displayOperators = this.items.filter(operator => this.filterName(operator.name, this.searchText))
  }

  public delete(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to delete?', this.viewRef)
      .then(result => {
        if (result) {
          this.loading = true;
          this.spinner.show();
          this.operatorService.delete(id)
            .subscribe(
              () => {
                this.spinner.hide();
                this.load();
              },
              error => {
                this.spinner.hide();
                this.dialogService.error(
                  error,
                  `Unable to inactivate this operator`,
                  this.viewRef);
              }
            );

        }
      });
  }

  public reactivate(id: number) {
    this.dialogService.confirm('Confirm Reactivate', 'Are you sure you want to reactivate this station operator? They will be able to once again log into their assigned station', this.viewRef)
      .then(result => {
        if (result) {
          this.loading = true;
          this.spinner.show();
          this.operatorService.reactivate(id)
            .subscribe(
              () => {
                this.spinner.hide();
                this.load();
              },
              error => {
                this.spinner.hide();
                this.dialogService.error(
                  error,
                  `Unable to reactivate this operator`,
                  this.viewRef);
              }
            );

        }
      });
  }

  public resentInvite(id: number) {
    this.dialogService.confirm('Confirm Resend', 'Are you sure you want to resend an onboarding invite to this operator?', this.viewRef)
      .then(result => {
        if (result) {
          this.loading = true;
          this.spinner.show();

            this.operatorService.resendOnboardingUrl(id)
              .subscribe(
                _ => {
                  this.dialogService.alert(
                    'Invite Resent',
                    `An onboarding email has been resent`,
                    this.viewRef);

                    this.loading = false;
                    this.spinner.hide();
              },
              error => {

                let message = error.originalError || error.error || error;
                if (error.error instanceof ProgressEvent) {
                    message = error.statusText;
                }


                this.dialogService.alert(
                  'Uh oh something went wrong...',
                  `Unable to resend operator email: ${message}`,
                  this.viewRef);

                  this.loading = false;
                  this.spinner.hide();
              });
        }
      });
  }


  private load() {
    this.spinner.show();

    this.operatorService.getAll().subscribe(data => {
      this.items = data;
      this.toggleShowInactive();

      this.loading = false;
      this.spinner.hide();
    },
    error => {
      this.dialogService.alert(
        'Uh oh something went wrong...',
        `Unable to load operators: ${error.error}`,
        this.viewRef);

        this.loading = false;
        this.spinner.hide();
    });
  }

  toggleShowInactive() {
    if (this.showInactive) {
      this.displayOperators = this.items;
    } else {
      this.displayOperators = this.items.filter(o => o.active);
    }
  }

  public openStationLinkModal(operator: PosOperator) {
    const modalConfig = {
        backdrop: true,
        ignoreBackdropClick: true
    };

    const initialState = {
      operator: operator
    };

    this.bsModalRef = this.modalService
      .show(
        OperatorStationLinkModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-sm', initialState })
      );

    this.bsModalRef.content.hasError
      .subscribe(
        value => {
            if (value) {
              this.dialogService.alert('Error', `Unable to create station link`, this.viewRef);
            } else {
                this.load();
            }
      });
  }

  public create() {
    this.router.navigate(['/portal/fundraising/cue5050/operator/create']);
  }

  public edit(id: number) {
    this.router.navigate([`/portal/fundraising/cue5050/operator/update/${id}`]);
  }
}
